import { createContext, useContext, useState } from "react";
import type { ReactNode, RefObject } from "react";

import { useSearchBarListeners } from "./hooks";

type SearchBarContextValue = {
  isOpen: boolean;
  toggleOpen: () => void;
  setClosed: () => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  paneRef: RefObject<HTMLDivElement | null>;
};

const SearchBarContext = createContext<SearchBarContextValue | null>(null);

export const SearchBarProvider = ({ children }: { children: ReactNode }) => {
  const { isOpen, toggleOpen, setClosed, paneRef } = useSearchBarListeners();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <SearchBarContext.Provider
      value={{
        isOpen,
        toggleOpen,
        setClosed,
        searchTerm,
        setSearchTerm,
        paneRef,
      }}
    >
      {children}
    </SearchBarContext.Provider>
  );
};

export const useSearchBar = (): SearchBarContextValue => {
  const ctx = useContext(SearchBarContext);
  if (!ctx) {
    throw new Error("useSearchBar must be used within a SearchBarProvider");
  }
  return ctx;
};
